import makeHttpRequest from '../helpers/ajax';
import wwwUrlEnv from '../helpers/www-url-env';

const GetLatLong = (streetAddress) => {
    const url = `${wwwUrlEnv.getWWWURL()}/wp-json/getGeoCode/v1?address=${encodeURIComponent(streetAddress)}`;
    const errorResponse = { success: false, errorMessage: 'Unable to get coordinates for this address' };
    return makeHttpRequest({ url }).then((response) => {
        const location = JSON.parse(JSON.parse(response));
        try {
            return Promise.resolve({ success: true, location: { latitude: location.results[0].geometry.location.lat, longitude: location.results[0].geometry.location.lng } });
        } catch {
            return Promise.resolve(errorResponse);
        }
    }, () => Promise.resolve(errorResponse));
};

export default GetLatLong;
